import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders2_Vendor() {
      const [isScrolled, setIsScrolled] = useState(false);
    
      const settings = {
        slidesToShow: 6, 
        slidesToScroll: 1, 
        autoplay: true,
        autoplaySpeed: 2000, 
        arrows: false, 
        dots: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1024, // For screens smaller than 1024px
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 768, // For screens smaller than 768px
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 520, // For screens smaller than 520px
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };
    
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        setIsScrolled(scrollTop > 50);
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    
        const sliderRef = useRef(null);
      
        const play = () => {
          sliderRef.current.slickPlay();
        };
        const pause = () => {
          sliderRef.current.slickPause();
        };
  

  return (
    <div>
    <div className="about-company-main-sec">
    <div className="container">
        <div className="row">
            <div className="boxv1">
                <h5 className="tour-details-h5">Hotel Services</h5>
                <div className={`hotel-slides slider slides-wrapper ${ isScrolled ? "slider" : ""}`}>

                <Slider ref={sliderRef} {...settings}>
                    <div>
                        <a href="#">
                            <img className="vendour-hotel-package-img" 
                            src="assets/img/hotels/states/manali.png"/>
                            <h5 className="hotel-name-vendors">Manali</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img" 
                            src="assets/img/hotels/states/hyderabad.png"/>
                            <h5 className="hotel-name-vendors">Hyderabad</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img" 
                            src="assets/img/hotels/states/ayodhya.png"/>
                            <h5 className="hotel-name-vendors">Ayodhya</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img"
                             src="assets/img/hotels/states/mumbai.png"/>
                            <h5 className="hotel-name-vendors">Mumbai</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img" 
                            src="assets/img/hotels/states/goa.png"/>
                            <h5 className="hotel-name-vendors">Goa</h5>

                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img" 
                            src="assets/img/tours/bali.jpg"/>
                            <h5 className="hotel-name-vendors">Bali</h5>
                        </a>
                    </div>


                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img"
                             src="assets/img/tours/andaman.jpg"/>
                            <h5 className="hotel-name-vendors">Andaman</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img"
                             src="assets/img/tours/trending/chennai.jpg"/>
                            <h5 className="hotel-name-vendors">Chennai</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-hotel-package-img"
                             src="assets/img/tours/trending/kerala.jpg"/>
                            <h5 className="hotel-name-vendors">Kerala</h5>
                        </a>
                    </div>
                    </Slider>                
                    </div>

            </div>

        </div>
    </div>
</div>
    </div>
  );
}

export default Sliders2_Vendor;
